module.exports = __webpack_public_path__ + "img/20220720083018337fwf.70a3330a.jpg";